import _ from "lodash";
import {$store} from "@isudio/globals";
import {pages} from "@isudio/config";

export const MenuItems = [
  {
    "id": "services",
    "title": "Services",
    "visible": true,
    "icon": "fa-bell-concierge",
    "submenu": [
      {
        "id": "strategy",
        "title": "Strategy",
        "visible": true,
        "icon": "fa-head-side-brain",
        "route": "/strategy"
      },
      {
        "id": "research",
        "title": "Research",
        "visible": true,
        "icon": "fa-chart-mixed-up-circle-dollar",
        "route": "/research"
      },
      {
        "id": "identity",
        "title": "Identity",
        "visible": true,
        "icon": "fa-fingerprint",
        "route": "/identity"
      },
      {
        "id": "technology",
        "title": "Technology",
        "visible": true,
        "icon": "fa-microchip-ai",
        "route": "/technology"
      }
    ]
  },
  {
    "id": "work",
    "title": "Work",
    "visible": true,
    "icon": "fa-briefcase",
    "route": "/work"
  },
  {
    "id": "atheneum",
    "title": "Atheneum",
    "visible": true,
    "icon": "fa-books",
    "route": "/atheneum"
  },
  {
    "id": "topMenuSeperator",
    "visible": true,
    "seperator": "line"
  },
  {
    "id": "company",
    "title": "Company",
    "visible": true,
    "icon": "fa-building",
    "submenu": [
      {
        "id": "aboutus",
        "title": "About Us",
        "visible": true,
        "icon": "fa-building-magnifying-glass",
        "route": "/aboutUs"
      },
      {
        "id": "team",
        "title": "Team",
        "visible": true,
        "icon": "fa-people-roof",
        "route": "/team"
      },
      {
        "id": "careers",
        "title": "Careers",
        "visible": true,
        "icon": "fa-handshake-angle",
        "route": "/careers"
      },
      {
        "id": "sendBrief",
        "title": "Send Brief",
        "visible": true,
        "icon": "fa-paper-plane",
        "component": "Brief",
        "properties": {
          "dialog": {
            "name": "Send Brief",
            "modal": true,
            "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
          }
        },
        "toastSuccessMessage": "Transformation brief sent successfully."
      },
      {
        "id": "contactUs",
        "title": "Contact Us",
        "visible": true,
        "icon": "fa-phone-office",
        "component": "Contact",
        "properties": {
          "dialog": {
            "name": "Contact Us",
            "modal": true,
            "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
          }
        },
        "toastSuccessMessage": "Message sent successfully."
      }
    ]
  },
  {
    "id": "aboutUsSeperator",
    "visible": true,
    "seperator": "line"
  },
  {
    "id": "mbaZone",
    "title": "MBA Zone",
    "visible": () => {
      return _.isUserStudent() && _.isUserSignedIn();
    },
    "icon": "fa-user-graduate",
    "route": "/mbazone"
  },
  {
    "id": "mbaZoneSeperator",
    "visible": () => {
      return _.isUserStudent() && _.isUserSignedIn();
    },
    "seperator": "line"
  },
  {
    "id": "signUp",
    "title": "Sign up",
    "visible": () => {
      return !_.isUserAvailable() && !_.isUserSignedIn();
    },
    "icon": "fa-pen-swirl",
    "component": "Signup",
    "properties": {
      "dialog": {
        "name": "Signup",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
      }
    },
    "toastSuccessMessage": "Signup successful. Please check your registered email and activate your account."
  },
  {
    "id": "signIn",
    "title": "Sign in",
    "visible": () => {
      return !_.isUserAvailable() && !_.isUserSignedIn();
    },
    "icon": "fa-right-to-bracket",
    "component": "Signin",
    "properties": {
      "dialog": {
        "name": "Signin",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent",
        "userClass": true
      }
    },
    "includeUser": true,
    "toastSuccessMessage": "Sign in successful. Explore the menu and access personalized content."
  },
  {
    "id": "contactUs",
    "title": "Contact Us",
    "visible": false,
    "icon": "fa-phone-office",
    "component": "Contact",
    "properties": {
      "dialog": {
        "name": "Contact Us",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
      }
    },
    "toastSuccessMessage": "Message sent successfully."
  },
  {
    "id": "userProfile",
    "title": "Edit User Profile",
    "visible": false,
    "component": "UserProfile",
    "properties": {
      "dialog": {
        "name": "User Profile",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
      }
    },
    "includeUser": true,
    "toastSuccessMessage": "User profile saved successfully.",
  },
  {
    "id": "sendBrief",
    "title": "Send Brief",
    "visible": false,
    "component": "Brief",
    "properties": {
      "dialog": {
        "name": "Send Brief",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
      }
    },
    "toastSuccessMessage": "Transformation brief sent successfully."
  },
  {
    "id": "privacyPolicy",
    "title": "Privacy Policy",
    "visible": false,
    "component": "PrivacyPolicy",
    "properties": {
      "dialog": {
        "name": "Privacy Policy",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent",
        "nofitClass": true
      }
    }
  },
  {
    "id": "termsOfUse",
    "title": "Terms of Use",
    "visible": false,
    "component": "TermsOfUse",
    "properties": {
      "dialog": {
        "name": "Terms of Use",
        "modal": true,
        "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent",
        "nofitClass": true
      }
    }
  },
  {
    "id": "userMenu",
    "visible": () => {
      return _.isUserAvailable();
    },
    "user": () => {
      return _.isUserAvailable() ? {
        firstName: _.get($store, 'User.user.firstName'),
        lastName: _.get($store, 'User.user.lastName'),
        photo: _.get($store, 'User.user.photo.thumbnail') || pages.signup.mediaPicker.defaultProfilePic
      } : null;
    },
    "links": [
      {
        "id": "activateAccount",
        "visible": () => {
          return _.isUserActivationPending();
        },
        "title": "Activate",
        "component": "Activation",
        "properties": {
          "dialog": {
            "name": "Activate",
            "modal": true,
            "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent",
            "userClass": true
          }
        },
        "includeUser": true,
        "toastSuccessMessage": "User account activated. Please proceed to sign into your account and access personalized content."
      },
      {
        "id": "signIn",
        "visible": () => {
          return !_.isUserActivationPending() && !_.isUserSignedIn();
        },
        "title": "Sign in",
        "component": "Signin",
        "properties": {
          "dialog": {
            "name": "Signin",
            "modal": true,
            "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent",
            "userClass": true
          }
        },
        "includeUser": true,
        "toastSuccessMessage": "Sign in successful. Explore the menu to access personalized content."
      },
      {
        "id": "signout",
        "visible": () => {
          return _.isUserSignedIn();
        },
        "title": "Sign out",
        "action": "signout",
        "includeUser": true,
        "toastSuccessMessage": "Signed out from your account successfully."
      },
      {
        "id": "forgetAccount",
        "visible": () => {
          return !_.isUserSignedIn();
        },
        "title": "Forget Account",
        "action": "forgetAccount",
        "toastSuccessMessage": "Account cleared from cache."
      },
      {
        "id": "changePassword",
        "visible": () => {
          return _.isUserSignedIn();
        },
        "title": "Change Password",
        "component": "ChangePassword",
        "properties": {
          "dialog": {
            "name": "Change Password",
            "modal": true,
            "className": "p-0 border-0 rounded-sm md:rounded-md bg-transparent"
          }
        },
        "includeUser": true,
        "toastSuccessMessage": "Account password changed successfully."
      }
    ]
  }
];
